// src/components/Footer.js
import { useLocation, Link } from "react-router-dom";
import {
  FaYoutube,
  FaCommentDots,
  FaInstagram,
} from "react-icons/fa";

// 내부/외부 링크를 구분해서 관리 (지금은 모두 홈으로 연결)
const FOOTER_LINKS = [
  { label: "회사소개", to: "/" },
  { label: "이용약관", to: "/" },
  { label: "개인정보처리방침", to: "/" },
  { label: "청소년보호정책", to: "/" },
  { label: "운영정책", to: "/" },
  { label: "게임시간선택제", to: "/" },
  { label: "고객센터", to: "/" },
];

// 소셜 아이콘과 이동할 URL을 관리
const SOCIAL_LINKS = [
  { icon: FaYoutube, href: "https://www.youtube.com/@tv-je7vx" },
  { icon: FaCommentDots, href: "https://gonggamore.com/" },
  { icon: FaInstagram, href: "https://www.instagram.com/gonggamore/" },
];

export default function Footer() {
  const location = useLocation();
  if (["/login", "/signup"].includes(location.pathname)) {
    return null;
  }

  return (
    <footer className="bg-[#1f1f1f] text-gray-400 text-sm mt-12 pt-8 pb-6">
      <div className="container mx-auto space-y-6">

        {/* 1행: 왼쪽 정렬된 링크 + 오른쪽 정렬된 소셜 아이콘 */}
        <div className="flex justify-between items-center">
          <div className="flex space-x-6">
            {FOOTER_LINKS.map(({ label, to }) => (
              <Link
                key={label}
                to={to}  // 나중에 실제 경로로 변경 가능
                className="hover:text-white transition-colors"
              >
                {label}
              </Link>
            ))}
          </div>
          <div className="flex space-x-4">
            {SOCIAL_LINKS.map(({ icon: Icon, href }) => (
              <a
                key={href}
                href={href}
                target="_blank"
                rel="noreferrer"
                className="hover:text-white cursor-pointer"
              >
                <Icon size={18} />
              </a>
            ))}
          </div>
        </div>

        {/* 구분선 */}
        <hr className="border-t border-neutral-600" />

        {/* 2행: 왼쪽 정렬된 회사 정보 */}
        <div className="leading-relaxed space-y-1 text-xs md:text-sm">
          <p>
            (주)공감오레콘텐츠&nbsp;&nbsp;대표이사: 윤민형&nbsp;&nbsp;
            주소: 김해시 관동로 14 경남콘텐츠기업지원센터, 103호
          </p>
          <p>
            사업자등록번호: 473-88-02674&nbsp;&nbsp;
            통신판매업 신고번호: 제2024-김해장유-0081호&nbsp;&nbsp;
            사업자정보확인
          </p>
          <p>
            대표번호: 055-338-6705&nbsp;&nbsp;
            팩스: 055-338-6706&nbsp;&nbsp;
            이메일: gonggamore@gonggamore.co.kr&nbsp;&nbsp;
          </p>
        </div>

        {/* 3행: 왼쪽 저작권 */}
        <div className="text-gray-500 text-xs mt-6">
          © gonggamore. All Rights Reserved.
        </div>

        {/* 4행: 왼쪽 로고 */}
        <div className="mt-4">
          <img
            src="/images/logo/logo_main2.png"
            alt="Smilegate"
            className="h-20"
          />
        </div>
      </div>
    </footer>
  );
}
